module.exports = __webpack_public_path__ + "assets/c81213413eefc885f80b8979b5a43c19.png";